import Home from '../pages/home';
import Projects from '../pages/projects';
import Sandbox from '../pages/sandbox';
import Work from '../pages/work';
import ProjectsLoader from '../pages/projects-loader';

export const PortfolioRouting = [
  {
    path: '/damien-watson',
    element: <Home />,
  },
  {
    path: '/damien-watson/projects',
    element: <Projects />,
    children: [
      {
        path: '/damien-watson/projects/:id',
        element: <ProjectsLoader />,
      },
    ]
  },
  {
    path: '/damien-watson/sandbox',
    element: <Sandbox />,
  },
  {
    path: '/damien-watson/work',
    element: <Work />,
  },
];